import * as React from "react";
import type { SVGProps } from "react";
const SvgBottle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 14.19v-.39c0-1.9-.58-3.72-1.74-5.34A6.759 6.759 0 0 1 15 4.5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v.5c0 1.43-.44 2.79-1.31 4.03A9.061 9.061 0 0 0 6 13.8V20c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3v-5.81Zm-2.01-.54c-.3.22-.58.46-.8.77-.26.37-.69.58-1.18.58h-.06c-.45 0-.87-.22-1.14-.58-.64-.89-1.67-1.42-2.72-1.42h-.14c-.71 0-1.37.24-1.94.63.03-1.42.48-2.79 1.35-4.02.57-.8.99-1.69 1.26-2.62h2.75c.28.94.71 1.84 1.31 2.69a7.041 7.041 0 0 1 1.3 3.96l.01.01ZM11 4h2v1h-2V4Zm4 17H9c-.55 0-1-.45-1-1v-3.64c.31-.22.59-.47.81-.77.27-.38.71-.58 1.21-.58.49 0 .9.21 1.17.58.64.89 1.67 1.42 2.72 1.42h.14c.71 0 1.38-.24 1.95-.64v3.64c0 .55-.45 1-1 1V21Z"
    />
  </svg>
);
export default SvgBottle;
